import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Chip',
  props: {
  text: {
    type: String
  },
  style: {
    default: {
      color: '#2C8AFF',
      backgroundColor: '#EFF5FF'
    }
  }
},
  setup(__props) {

const props = __props



const propsDefine = ref({
  ...props,
  style: {
    ...props.style,
    border: `1px solid ${props.style?.color}`
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "px-4 py-2 inline rounded-lg font-bold text-sm" }, propsDefine.value), _toDisplayString(props.text), 17))
}
}

})